import classNames from 'classnames';
import React from 'react';

import styles from './Toggle.module.css';

export interface ToggleProps {
	value: boolean;
	onChange: (v: boolean) => void;
	label?: React.ReactNode;
	disabled?: boolean;
}

export const Toggle = ({value, onChange, label, disabled}: ToggleProps): React.ReactElement => {
	const handler = React.useCallback(() => {
		onChange(!value);
	}, [value, onChange]);

	const toggle = (
		<div
			className={classNames(styles.toggle, {[styles.active]: value, [styles.disabled]: disabled})}
			onClick={handler}
			role={'checkbox'}
		>
			<div className={styles.circle} />
		</div>
	);

	if (label) {
		return (
			<div className={classNames(styles.wrapper, {[styles.disabled]: disabled})}>
				{toggle}
				<div className={styles.label} onClick={handler}>
					{label}
				</div>
			</div>
		);
	}

	return toggle;
};
